import { render } from "./ResendOrder.vue?vue&type=template&id=35d0d4c1&scoped=true"
import script from "./ResendOrder.vue?vue&type=script&lang=js"
export * from "./ResendOrder.vue?vue&type=script&lang=js"

import "./ResendOrder.vue?vue&type=style&index=0&id=35d0d4c1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d0d4c1"]])

export default __exports__